// @ts-nocheck
import { convertCanvas2DToWebGLPoint, convertWebGLToCanvas2DPoint } from "../../shared/common";
import { Point } from "../Point";
// Import Vector - use relative path like Line.ts does
import { Vector } from "../Vector";

export class AbstractFrame {
    private _start: Point;
    private _end: Point;
    
    type: string;
    color: any[];
    skew: number;
    initVec: Vector;
    vec: Vector;
    point1: Point;
    point2: Point;
    point3: Point;
    point4: Point;

    get start() {
        return this._start;
    }
    set start(point) {
        this._start = point ? point.clone() : null;
        this.setPoints();
    }
    get end() {
        return this._end;
    }
    set end(point) {
        this._end = point ? point.clone() : null;
        this.setPoints();
    }


    constructor(start, end, color) {
        this.type = 'select_frame';

        this.color = [...color];
        this._start = start.clone();
        this._end = end.clone();
        this.skew = 0;
        
        // Ensure Vector is a constructor before using it
        if (typeof Vector === 'undefined' || typeof Vector !== 'function') {
            throw new Error(`Vector class is not available. Type: ${typeof Vector}. Make sure Vector is imported before AbstractFrame.`);
        }
        
        this.initVec = new Vector(this._start, new Point(this._start.x, 1));
        this.vec = new Vector(this._start, this._end);

    }

    setPoints() {
        // Initialize points to null if start or end is null
        if (!this.start || !this.end) {
            this.point1 = null;
            this.point2 = null;
            this.point3 = null;
            this.point4 = null;
            return;
        }

        const width = this.end.x - this.start.x;
        const height = this.end.y - this.start.y;

        if (width >= 0 && height >= 0) {
            // Positive width and height, draw from top left to bottom right
            this.point1 = new Point(this.start.x, this.start.y + height);
            this.point2 = new Point(this.start.x + width, this.start.y + height);
            this.point3 = new Point(this.start.x + width, this.start.y);
            this.point4 = new Point(this.start.x, this.start.y);
        } else if (width < 0 && height >= 0) {
            // Negative width, positive height, draw from top right to bottom left
            this.point1 = new Point(this.start.x + width, this.start.y + height);
            this.point2 = new Point(this.start.x, this.start.y + height);
            this.point3 = new Point(this.start.x, this.start.y);
            this.point4 = new Point(this.start.x + width, this.start.y);
        } else if (width >= 0 && height < 0) {
            // Positive width, negative height, draw from bottom left to top right
            this.point1 = new Point(this.start.x, this.start.y);
            this.point2 = new Point(this.start.x + width, this.start.y);
            this.point3 = new Point(this.start.x + width, this.start.y + height);
            this.point4 = new Point(this.start.x, this.start.y + height);
        } else {
            // Negative width and height, draw from bottom right to top left
            this.point1 = new Point(this.start.x + width, this.start.y);
            this.point2 = new Point(this.start.x, this.start.y);
            this.point3 = new Point(this.start.x, this.start.y + height);
            this.point4 = new Point(this.start.x + width, this.start.y + height);
        }

        this.vec.start = this.start.clone();
        this.vec.end = this.end.clone();

        this.skew = this.vec.getSkewProduct(this.initVec);




    }

    convertToCanvas2d(canvasWidth, canvasHeight) {
        this.point1 = convertWebGLToCanvas2DPoint(this.point1, canvasWidth, canvasHeight);
        this.point2 = convertWebGLToCanvas2DPoint(this.point2, canvasWidth, canvasHeight);
        this.point3 = convertWebGLToCanvas2DPoint(this.point3, canvasWidth, canvasHeight);
        this.point4 = convertWebGLToCanvas2DPoint(this.point4, canvasWidth, canvasHeight);

    }

    deconvert(canvasWidth, canvasHeight) {
        this.point1 = convertCanvas2DToWebGLPoint(this.point1, canvasWidth, canvasHeight);
        this.point2 = convertCanvas2DToWebGLPoint(this.point2, canvasWidth, canvasHeight);
        this.point3 = convertCanvas2DToWebGLPoint(this.point3, canvasWidth, canvasHeight);
        this.point4 = convertCanvas2DToWebGLPoint(this.point4, canvasWidth, canvasHeight);
    }

    getVertices() {
        return new Float32Array([
            this.point1.x, this.point1.y,
            this.point2.x, this.point2.y,
            this.point3.x, this.point3.y,
            this.point4.x, this.point4.y
        ])
    }
}